import { AfterViewInit, Component, ElementRef,ViewChild, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, NgForm ,FormControl} from '@angular/forms';
import { ActivatedRoute, ParamMap,Router } from '@angular/router';
import * as bootstrap from 'bootstrap';
import { getParamsType } from '../model/getParamsType';
import { SharedService } from 'src/app/services/shared.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { DatePipe } from '@angular/common'
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { okButtonText, modalMessageText, deleteEvent, cancelButtonText } from 'src/app/constants';
import { ModalComponent } from 'src/app/modal/modal.component';
import { GoogleAnalyticsService } from '../DataLayer/google-analytics-service.service';

@Component({
    selector: 'app-clinic-details',
    templateUrl: './clinic-details.component.html',
    styleUrls: ['./clinic-details.component.scss'],
    standalone: false
})

export class ClinicDetailsComponent implements OnInit,AfterViewInit {
  @ViewChild('focuss') myInputt: ElementRef;
  days = [
    {name: 'Monday',islected:false} ,             
    {name: 'Tuesday',   islected:false} ,

    {name: 'Wednesday',islected:false},
    {name: 'Thursday',   islected:false} ,
    {name: 'Friday',islected:false},
    {name: 'Saturday',   islected:false},
    {name: 'Sunday',   islected:false}  
   ];
  
   ccn:any;
   sta:any;
   cln:any;
   cfn:any;
   cn:any;
   stt : any;
   cty:any;
   zip:any;
  cName: boolean = false;
  oName: boolean = false;
  olName: boolean = false;
  addr: boolean = false;
  phNum: boolean = false;
  state : boolean = false;
  city : boolean = false;
  zipcodee: boolean = false;
  showAllErrors: boolean = false;
  clinicData : any;
  tileClinicName : any
  tileStreetAddress : any
  tileDate : any
  clinicsList = ([] as any[]);
  isValidClinicPart : Boolean = false;
  todayDate =  new Date(); 
  todayDate1 = new Date(this.todayDate.getFullYear(),this.todayDate.getMonth(),this.todayDate.getDate())
  datePickerLabel="Specific date in mm/dd/yyyy format";
  minDate : Date;
  pastDate : Boolean = false ;
  isDateEventTouched : Boolean = false;
  
  dayError: Boolean = true;
  selectedDays: Array<string> = [];
  isMulti : boolean = false;
  IsNotMulti : boolean = false;
  isDate : boolean = false;
  IsNoDate : boolean = false;
  aci_ismultidayclinic : any;
  dateErrorMessage : boolean = false;
  wrongDateFormat : Boolean = false;
  aci_estimateofdoses:any;
  aci_clinicnoteimportantinformation:any;
  servicesListForLead : Array<string> = [];
  servicesList : string = '';
  isFromMultiClinic : Boolean = false ;



  nestedForm: FormGroup = new FormGroup({});
  leadId: any;
  clinicId : any;
  leadType : any;
  firstLoad: boolean = false;
  loading: boolean = false;
  aci_isthereaspecificdateyoudliketohold : any;
  dateOfBirth : any;
  showTile : Boolean =false;
  showTile_Multi : Boolean = this.isFromMultiClinic || this.showTile
  aci_clinicName:any;
  aci_cliniccontactname:any;
  aci_onsitecontactlastname:any;
  aci_cliniccontactphonenumber:any;
  aci_streetaddress:any;
  isMorning : Boolean =false;
  isNoon : Boolean =false;
  isEvening : Boolean =false;
  isFlexible : Boolean =false;
  isAnyTimeSelected : Boolean = false;
  clinicSubscriber: any;
  action: string | null;
  gid: string | null;
  hideButtons : Boolean = false;
  aci_state:any;
  aci_city:any;
  aci_companyname:any;
  aci_zipcode:any;
  autoFillZip: boolean = false;
  fetchZipLoading: boolean = false;
  zipCodes: any[] = []; 
  aci_stateValue:any;
  aci_zipcodeValue:any;
  isValidZipcode: boolean = true;
  clinicCount : any;
  companySizeMaxlength: number;
  previuosButtonTabIndex: any = -1;
  AriaTextSubmitBtn:any;
  AriaTextTimingFlex:any ="I'm flexible";
  AriaTextTimingMorn:any="Is there a preferred time of day for this clinic ? Morning";
  AriaTextTimingAft:any="Afternoon ";
  AriaTextTimingEve:any="Evening";
  companyname: any;
  
  constructor(private router: Router, private _fb: FormBuilder,
    protected $gaService: GoogleAnalyticsService,
    private route: ActivatedRoute,public sharedService: SharedService,public datepipe: DatePipe,private modalService: NgbModal) { 

      
    }

    ngAfterViewInit(): void {
   
    }

  ngOnInit(): void {


    
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.get('id');
      this.clinicId = params.get('clinicId');
      this.leadType = params.get('leadType');
      this.action = params.get('action')
      this.gid = params.get('gid')
      if(this.gid)
      {
        this.clinicId = this.gid;
      }
      if(this.clinicId)
      {
        this.gid = this.clinicId;
      }
      if (this.gid && (this.action==='RE' || this.action === 'CE')) 
      {
        this.hideButtons = true;
        this.getClinicDetails(this.gid);
      }
      if(this.leadId && (this.action==='back' || this.action==='frombilling'))
      {
        this.getClinicDetailsByLead();
      }
      if(this.clinicId && this.leadType==='Updateclinic')
      {
        this.getClinicDetails(this.clinicId);
      }
      if(this.leadId && (this.leadType==='multipleclinic' || this.leadType==='singleclinic'))
      {
        this.getClinicDetailsByLead();
      }
      if(this.leadId && this.leadType ==='Createclinic')    
      {
        this.getLeadDetails();
      }
    });

    var device = this.$gaService.mobileOrLaptopdevice();
    if(device=="Mobile"){
    
      this.AriaTextSubmitBtn= "Next button double tap to activate the "
      this.AriaTextTimingMorn="Is there a preferred time of day for this clinic ? Morning radio button double tap to activate "
      this.AriaTextTimingAft="Afternoon radio button double tap to activate "
      this.AriaTextTimingEve="Evening radio button double tap to activate "
      this.AriaTextTimingFlex="I'm flexible radio button double tap to activate "
    }
    else{
      this.AriaTextSubmitBtn ="Next";
    }



  }


  openClinicTab()
  {
     

     this.showTile = false;
     this.isFromMultiClinic = true;
     this.showTile_Multi = this.showTile || this.isFromMultiClinic
     this.isMulti = false;
     this.IsNotMulti = false;
     this.isDate = false ;
     this.IsNoDate = false;
     this.isMorning = false;
     this.isNoon = false;
     this.isEvening = false;
     this.isFlexible = false;
     this.aci_estimateofdoses = '';
     this.aci_clinicnoteimportantinformation = '';
    this.days.forEach((d) => {
       d.islected = false;
       });
    this.dateOfBirth = '';
    this.dayError = true;
    this.dateErrorMessage = false;
    this.wrongDateFormat = false;
    this.isAnyTimeSelected = false;
    this.firstLoad = false;
     this.aci_clinicName='';
     this.aci_cliniccontactname= '';
     this.aci_cliniccontactphonenumber ='';
     this.aci_streetaddress = '';
     this.aci_onsitecontactlastname = ''
     this.aci_city='';
     this.aci_companyname='';
     this.aci_state='';
     this.aci_zipcode='';
     this.cName = false ;
     this.oName = false ;
     this.olName = false ;
     this.phNum = false ;
     this.addr = false ;
     this.zipcodee = false;
     this.city =false;
     this.state =false;


  }

  addDaysControls() {
    const arr = this.days.map(item => {
      return this._fb.control(false);
    });

    return this._fb.array(arr);
  }

  get daysArray() {
    return <FormArray>this.nestedForm.get('dayControls');
  }

  checkDayControlsTouched() {
    let flag = false;
    this.daysArray.controls.forEach(control => {
      if (control.touched) {
        flag = true;
      }
    });

    return flag;
  }

  getClinicDetailsByLead()
  {
   
    const relativePath: string = `groupclinic/getClinicByLeadId`;
    const getParams: getParamsType = {
      entityName: 'aci_clinic',
      entityId: this.leadId,
      columns:
        'aci_clinicid,aci_clinictype,aci_immunizationtype,aci_clinicservicetype,aci_ismultidayclinic,aci_isthereaspecificdate,aci_proposedtimeofdays,aci_clinicname,aci_cliniccontactname,aci_onsitecontactlastname,aci_cliniccontactphonenumber,aci_streetaddress,aci_monday,aci_tuesday,aci_wednesday,aci_thursday,aci_friday,aci_saturday,aci_sunday,aci_isthereaspecificdateyoudliketohold,aci_estimateofdoses,aci_clinicnoteimportantinformation,_aci_zipcodeid_value,aci_city,aci_companyname,_aci_stateid_value',
    };
    this.loading = true;
    this.clinicSubscriber = this.sharedService
      .postRequest(relativePath, getParams)
      .subscribe(
        (response) => {
          this.clinicsList = response.value;
          this.clinicCount = this.clinicsList.length;
          if(this.clinicCount == 1 && this.action=='frombilling')
          {
            this.clinicId = this.clinicsList[0].aci_clinicid;
          }
          if(this.aci_clinicName ){}

          this.bindClinicDataByLead(response.value);

          this.loading = false;
        },
        (errorResponse) => {
          this.loading = false;
          console.log(errorResponse);
        }
      );

  }


  getSelectedPrefferedTime($event:any)
  {
    const name = $event.target.value;
    const cehcked = $event.target.checked;

    var device1 = this.$gaService.mobileOrLaptopdevice();
    if(device1=="Mobile"){

      
     if(name=='Morning' && cehcked)
     {
      this.AriaTextTimingMorn="Is there a preferred time of day for this clinic ? Morning "
     }
     else if(name=='Morning' && !cehcked) 
     {
      this.AriaTextTimingMorn="Is there a preferred time of day for this clinic ? Morning radio button double tap to activate "
     }

     if(name=='Afternoon' && cehcked)
     {
      this.AriaTextTimingAft="Afternoon "
     }
     else if(name=='Afternoon' && !cehcked)
     {
      this.AriaTextTimingAft="Afternoon radio button double tap to activate "      
     }

     if(name=='Evening' && cehcked)
     {
      this.AriaTextTimingEve="Evening "
     }
     else if(name=='Evening' && !cehcked)
     {
      this.AriaTextTimingEve="Evening radio button double tap to activate "
     }
     
     if(name=='flexible' && cehcked)
     {
      this.AriaTextTimingFlex="I'm flexible"
     }
     else if(name=='flexible' && !cehcked)
     {
      this.AriaTextTimingFlex="I'm flexible radio button double tap to activate "
     }

     
      
    }

    this.isMorning = (name=='Morning' && cehcked) ? true : false
    this.isNoon = (name=='Afternoon' && cehcked) ? true : false
    this.isEvening = (name=='Evening' && cehcked) ? true : false
    this.isFlexible = (name=='flexible' && cehcked) ? true : false

    this.isAnyTimeSelected = (this.isMorning || this.isNoon  || this.isEvening || this.isFlexible) ? true : false;
    if(this.isAnyTimeSelected)
    {
      this.firstLoad=true;
    }

  
    
  }

  

  getSelectedServiceValue($event: any) {
    this.selectedDays = [];
    const name = $event.target.value;
    const cehcked = $event.target.checked;
    if(cehcked)
    {
      this.firstLoad=true;
      
    }
    this.days = this.days.map((d)=>{
       if(d.name==name)
       {        
         d.islected=cehcked;
         return d
       }
       return d;
    });
    this.days.forEach((d)=>{
       if(d.islected)
       {
         this.selectedDays.push(d.name);
       }
   });
      this.dayError =  this.selectedDays.length > 0 ? false : true;
      if (this.dayError)
      {
        this.firstLoad=true;
      }
     }

  onFormSubmit(form: NgForm) {
    if(this.action != 'CE' && this.action != 'RE')
    {
      if(this.isFromMultiClinic)
      {
        if(form.valid)
        {

          this.loading = true;
          let submitObj = JSON.parse(JSON.stringify(form.value));
          let submitObjLead : any;

          submitObj.aci_stateValue=this.aci_stateValue;
          submitObj.aci_zipcodeValue=this.aci_zipcodeValue;
    
          if (this.aci_stateValue)
          {
            submitObj[
              'aci_StateId@odata.bind'
            ] = `/aci_states(${this.aci_stateValue})`;

            
  
          }     

        if (this.aci_zipcodeValue)
        {
          submitObj[
            'aci_ZipCodeId@odata.bind'
          ] = `/aci_zipcodes(${this.aci_zipcodeValue})`;
        }


          submitObj['aci_LeadId@odata.bind'] = `/leads(${this.leadId})`;
          submitObj['LeadId'] = this.leadId;

  
          delete submitObj.specificTimeMorning;
          delete submitObj.specificTimeAfternoon;
          delete submitObj.specificTimeEvening;
          delete submitObj.specificTimeflexible;
          delete submitObj.aci_clinicnoteimportantinformation;
          delete submitObj.aci_estimateofdoses;
          delete submitObj.aci_isthereaspecificdateyoudliketohold;
          delete submitObj.dateOfBirth;
          delete submitObj.aci_ismultidayclinic;
          delete submitObj.aci_isthereaspecificdate;

          this.sharedService.postRequest('groupclinic/createClinic', submitObj).subscribe(res => {
      
            
            this.getClinicDetailsByLead();
            this.loading = false;
           }, errorResponse => {
               this.loading = false;
             });
  
  
  
        }
        else{
     
          this.showAllErrors = true;
          form.value.aci_clinicName = "" ? this.cName = false : this.cName = true;
          form.value.aci_cliniccontactname = "" ? this.oName = false : this.oName = true;
          form.value.aci_onsitecontactlastname = "" ? this.olName = false : this.olName = true;
          form.value.aci_streetaddress = "" ? this.phNum = false : this.phNum = true;
          form.value.pNum = "" ? this.addr = false : this.addr = true;
        }
  
      }
      else{
        if(form.valid)
        {
        
          this.loading = true;
        
          let submitObj = JSON.parse(JSON.stringify(form.value));
          
          submitObj.aci_stateValue=this.aci_stateValue;
          submitObj.aci_zipcodeValue=this.aci_zipcodeValue;
          submitObj.aci_companyname = this.companyname;
          if(submitObj.aci_clinicName){
            
          }
          else{
            submitObj.aci_clinicName = this.companyname + " (NOT PROVIDED)";
          }
    
          if (this.aci_stateValue)
          submitObj[
            'aci_StateId@odata.bind'
          ] = `/aci_states(${this.aci_stateValue})`;
        if (this.aci_zipcodeValue)
          submitObj[
            'aci_ZipCodeId@odata.bind'
          ] = `/aci_zipcodes(${this.aci_zipcodeValue})`;
          
          
          if (submitObj.aci_ismultidayclinic == 'Yes') {
            submitObj.aci_ismultidayclinic = true;
          } else {
            submitObj.aci_ismultidayclinic = false;
          }
      
          if (submitObj.aci_isthereaspecificdateyoudliketohold == 'Yes') {
            submitObj.aci_isthereaspecificdateyoudliketohold = true;
          } else {
            submitObj.aci_isthereaspecificdateyoudliketohold = false;
          }
    
          if(this.IsNoDate)
          {
            submitObj['aci_isthereaspecificdate'] = null; 
            this.dateErrorMessage = false;
            this.pastDate = false ;
            this.wrongDateFormat = false;
          }
          else{
            submitObj['aci_isthereaspecificdate'] = this.datepipe.transform(this.dateOfBirth, 'MM/dd/YYYY');
        
          }
          delete submitObj.dateOfBirth;
      
          this.days.forEach((d) => {
            if (d.islected) {
                const propName = 'aci_' + d.name.toLowerCase();
                submitObj[propName] = true;
            }
        });
        
      
          let serviceValueObj: string[] = [];
          if(this.isMorning)
          {
            serviceValueObj.push('805170000')
          }
          if(this.isNoon)
          {
            serviceValueObj.push('805170001')
          }
          if(this.isEvening)
          {
            serviceValueObj.push('805170002')
          }
          if(this.isFlexible)
          {
            serviceValueObj.push('805170003')
          }
          
      
          
          if (serviceValueObj.length > 0) {
            submitObj['aci_proposedtimeofdays']  = serviceValueObj.join(',');
          }

          submitObj['aci_LeadId@odata.bind'] = `/leads(${this.leadId})`;

          submitObj['LeadId'] = this.leadId;
      
          delete submitObj.specificTimeMorning;
          delete submitObj.specificTimeAfternoon;
          delete submitObj.specificTimeEvening;
          delete submitObj.specificTimeflexible;
      
      
          submitObj['entityId'] = this.clinicId;



    
          this.sharedService
            .postRequest('groupclinic/updateClinic', submitObj)
            .subscribe(
              (response) => {

                this.getClinicDetailsByLead();
                
              },
              (errorResponse) => {
                this.loading = false;
                console.log(errorResponse);
              }
            );
      
        }
        else {
          this.showAllErrors = true;
          form.value.aci_clinicName = "" ? this.cName = false : this.cName = true;
          form.value.aci_cliniccontactname = "" ? this.oName = false : this.oName = true;
          form.value.aci_onsitecontactlastname = "" ? this.olName = false : this.olName = true;
          form.value.aci_streetaddress = "" ? this.phNum = false : this.phNum = true;
          form.value.pNum = "" ? this.addr = false : this.addr = true;
        }
      }
    }
 
  
    
  }

  onYesclick(){
    this.isMulti = true;
    this.IsNotMulti = false;
    this.selectedDays = [] ;
    this.days.forEach((d)=>{
      if(d.islected)
      {
        this.selectedDays.push(d.name);
      }
  });
     this.dayError =  this.selectedDays.length > 0 ? false : true;

  }

  addEvent(event:any) {


    this.isDateEventTouched = true ;
    if(this.isDate && event.value!=null)
      {
        this.dateErrorMessage = false;
        this.wrongDateFormat = false;
	         if (event.value < this.todayDate1)
              {               
                this.pastDate = true ;
                this.datePickerLabel = '';
              }
              else{
                this.pastDate = false ;
                this.datePickerLabel = 'selected date is ' + this.datepipe.transform(this.dateOfBirth, 'MM/dd/YYYY');
              }
      }
      else if(this.myInputt.nativeElement.value != '')
      {
        this.pastDate = false ;
        this.wrongDateFormat = true;
        this.dateErrorMessage = false;
        this.datePickerLabel = '';
      }
      else{
        this.dateErrorMessage = true;
        this.wrongDateFormat = false;
        this.pastDate = false ;
        this.datePickerLabel = '';
      }
  }

  onNoclick(){
    this.IsNotMulti = true;
    this.isMulti = false;
    this.firstLoad=true;
    this.dayError=false;
  
   this.days.forEach((d) => {
    d.islected = false;
    });

  }

  onDateClick(id : string){
    this.isDate=true;
    
    
    this.myInputt.nativeElement.focus();
    
    this.IsNoDate = false;

  }

  onClosed(formControl:any){
    formControl.control.markAsTouched();
  }

  onNoDateClick(){
    this.isDateEventTouched = true ;
    this.IsNoDate = true;
    this.isDate=false;
   this.pastDate = false ;
    this.dateErrorMessage=false;
    this.dateOfBirth = null;
    this.wrongDateFormat = false;
  }

  onPreviousClick() {

    if (this.clinicCount > 1)
    {
      this.router.navigate(['/services', { id: this.leadId , action : "multipleclinic" }])
  
    }
    else if (this.clinicCount == 1)
    {
      this.router.navigate(['/services', { id: this.leadId , gid : this.clinicsList[0].aci_clinicid , action : "singleclinic" }])
    }
    else{
      this.router.navigate(['/services', { id: this.leadId ,gid : this.clinicId , action : "noclinic" }])
    }
  }

  onNexttClick(){

    if(this.leadType=='Createclinic')
    {
      this.router.navigate(['/billing', {id: this.leadId, leadType: "create" }])
    }
    else{
      this.router.navigate(['/billing', {id: this.leadId, leadType: "update" }])
    }
    
  }

  getClinicDetails(clinicId: any) {
    const relativePath: string = `groupclinic/getClinic`;
    const getParams: getParamsType = {
      entityName: 'aci_clinic',
      entityId: clinicId,
      columns:
        'aci_clinicid,aci_clinictype,aci_immunizationtype,_aci_leadid_value,aci_clinicservicetype,aci_ismultidayclinic,aci_isthereaspecificdate,aci_proposedtimeofdays,aci_clinicname,aci_cliniccontactname,aci_onsitecontactlastname,aci_cliniccontactphonenumber,aci_streetaddress,aci_monday,aci_tuesday,aci_wednesday,aci_thursday,aci_friday,aci_saturday,aci_sunday,aci_isthereaspecificdateyoudliketohold,aci_estimateofdoses,aci_clinicnoteimportantinformation,_aci_zipcodeid_value,aci_city,aci_companyname,_aci_stateid_value',
    };
    this.loading = true;
    this.clinicSubscriber = this.sharedService
      .postRequest(relativePath, getParams)
      .subscribe(
        (response) => {
          this.clinicData = response;
          if (this.clinicData) {
            this.gid = this.clinicId;
            this.bindClinicData(response);
          }
          this.loading = false;
        },
        (errorResponse) => {
          this.loading = false;
          console.log(errorResponse);
        }
      );
  }

  bindClinicData(response:any){

    this.leadId = response._aci_leadid_value;
    let covid19;
    let flu;
    let shingrix;
    let tdap;
    let pneumonia;

    var zipCodeValue=response['_aci_zipcodeid_value@OData.Community.Display.V1.FormattedValue'];
    if(response['_aci_zipcodeid_value@OData.Community.Display.V1.FormattedValue'] && response['_aci_zipcodeid_value@OData.Community.Display.V1.FormattedValue'].toString().length==4){
    zipCodeValue=`0${response['_aci_zipcodeid_value@OData.Community.Display.V1.FormattedValue']}`;
    }
    this.aci_city = response.aci_city;
    this.aci_state =
        response[
          '_aci_stateid_value@OData.Community.Display.V1.FormattedValue'
        ]

    this.aci_stateValue = response._aci_stateid_value;
    this.aci_zipcodeValue  = response._aci_zipcodeid_value;
    this.aci_zipcode = zipCodeValue ? zipCodeValue : '' ;
    this.autoFillZip = false;
    this.fetchZipLoading = false;
    this.isValidZipcode = true;

     if(response.aci_ismultidayclinic)
    {
      this.dayError = false;
      this.aci_ismultidayclinic='Yes'
      this.isMulti=true;
      this.days.forEach(d => {
         if(d.name=='Monday' && response.aci_monday)
         {
           d.islected=true;
         }
         if(d.name=='Tuesday' && response.aci_tuesday)
         {
           d.islected=true;
         }
         if(d.name=='Wednesday' && response.aci_wednesday)
         {
           d.islected=true;
         }
         if(d.name=='Thursday' && response.aci_thursday)
         {
           d.islected=true;
         }
         if(d.name=='Friday' && response.aci_friday)
         {
           d.islected=true;
         }
         if(d.name=='Saturday' && response.aci_saturday)
         {
           d.islected=true;
         }
         if(d.name=='Sunday' && response.aci_sunday)
         {
           d.islected=true;
         }
      });

    }
    else{
      this.dayError = false;
      this.aci_ismultidayclinic='No'
      this.IsNotMulti=true;
    }

    
    if(response.aci_isthereaspecificdateyoudliketohold)
    {
      this.dateErrorMessage = false;
      this.wrongDateFormat = false;
      this.isDateEventTouched = true;
      this.pastDate = false ;
      this.isDate=true;
      this.aci_isthereaspecificdateyoudliketohold='Yes'
      this.dateOfBirth = response.aci_isthereaspecificdate;
    }
    else{
      this.dateErrorMessage = false;
      this.isDateEventTouched = true;
      this.wrongDateFormat = false;
      this.IsNoDate = true;
      this.pastDate = false ;
      this.aci_isthereaspecificdateyoudliketohold='No'
    }

    if (response.aci_proposedtimeofdays) {
      this.isAnyTimeSelected=true;
      let proposedtimeArray =
        response.aci_proposedtimeofdays.split(',');
      proposedtimeArray.map((row: any) => {
        if (row == '805170000') {
          this.isMorning = true;
        }
        if (row == '805170001') {
          this.isNoon= true;
        }
        if (row == '805170002') {
          this.isEvening = true;
        }
        if (row == '805170003') {
          this.isFlexible = true;
        }
      });
    }




    this.aci_estimateofdoses = response.aci_estimateofdoses;
    this.aci_clinicnoteimportantinformation = response.aci_clinicnoteimportantinformation;
   
    if (response.aci_immunizationtype) {
      let immunizationArray = response.aci_immunizationtype.split(',');
    
      immunizationArray.map((row: any) => {
        if (row == '805170000') {
          covid19 = true;
          this.servicesList+= 'COVID-19, ';
          
        }
        if (row == '805170001') {
          flu = true;
          this.servicesList+= 'Flu, ';
        }
        if (row == '805170003') {
          shingrix = true;
          this.servicesList+= 'Shingles, ';
        }
        if (row == '805170004') {
          tdap = true;
          this.servicesList+= 'Tetanus, '; 
        }
        if (row == '805170005') {
          pneumonia = true;
          this.servicesList+= 'Pneumonia, '; 
        }
        if (row == '805170006') {
          pneumonia = true;
          this.servicesList+= 'Hepatitis B, '; 
        }
      });
    }
    let covid19testing;
    let a1ctesting;
    let cholestrol;
    let bloodglucose;
  
    
    if (response.aci_clinicservicetype) {
      let serviceArray = response.aci_clinicservicetype.split(',');
      serviceArray.map((row: any) => {
        if (row == '805170000') {
          covid19testing = true;
          this.servicesList+= 'Covid-19 Testing, ';
        }
        if (row == '805170006') {
          covid19testing = true;
          this.servicesList+= 'Travel Health, ';
        }
        if (row == '805170005') {
          covid19testing = true;
          this.servicesList+= response.aci_otherservicetype + ', ';
        }
        if (row == '805170001') {
          a1ctesting = true;
          this.servicesList+= 'A1C, ';
        }
        if (row == '805170002') {
          cholestrol = true;
          this.servicesList+= 'Cholesterol/Lipid Panel, ';
        }
        if (row == '805170003') {
          bloodglucose = true;
          this.servicesList+= 'Blood Glucose, ';
        }
        
      });
    }

    this.aci_clinicName = response.aci_clinicname;
    this.aci_cliniccontactname = response.aci_cliniccontactname;
    this.aci_cliniccontactphonenumber = response.aci_cliniccontactphonenumber;
    this.aci_onsitecontactlastname = response.aci_onsitecontactlastname;
    this.aci_streetaddress = response.aci_streetaddress;
    this.aci_companyname = response.aci_companyname;


    
  }

  bindClinicDataByLead(response:any){

    let covid19;
    let flu;
    let shingrix;
    let tdap;
    let pneumonia;

    let covid19testing;
    let a1ctesting;
    let cholestrol;
    let bloodglucose;
    
  


    this.clinicsList.forEach(element => {
      element.aci_isthereaspecificdate = element.aci_isthereaspecificdateyoudliketohold ? this.datepipe.transform(element.aci_isthereaspecificdate, 'MM/dd/YYYY') : 'NO';

    });
   
    this.showTile=true;
    this.showTile_Multi  = this.isFromMultiClinic || this.showTile

  }

  NavigateToRequestSubmit(form: NgForm){
 
    if(form.valid)
      {
        this.loading = true;
      
        let submitObj = JSON.parse(JSON.stringify(form.value));

        submitObj.aci_stateValue=this.aci_stateValue;
        submitObj.aci_zipcodeValue=this.aci_zipcodeValue;
       
  
        if (this.aci_stateValue)
        submitObj[
          'aci_StateId@odata.bind'
        ] = `/aci_states(${this.aci_stateValue})`;
      if (this.aci_zipcodeValue)
        submitObj[
          'aci_ZipCodeId@odata.bind'
        ] = `/aci_zipcodes(${this.aci_zipcodeValue})`;
     
        
        
        if (submitObj.aci_ismultidayclinic == 'Yes' ||  submitObj.aci_ismultidayclinic  == true || this.isMulti==true) {
          submitObj.aci_ismultidayclinic = true;
        } else {
          submitObj.aci_ismultidayclinic = false;
        }
    
        if (submitObj.aci_isthereaspecificdateyoudliketohold == 'Yes' || submitObj.aci_isthereaspecificdateyoudliketohold == true || this.isDate) {
          submitObj.aci_isthereaspecificdateyoudliketohold = true;
        } else {
          submitObj.aci_isthereaspecificdateyoudliketohold = false;
        }
  
        if(this.IsNoDate)
        {
          submitObj['aci_isthereaspecificdate'] = null;
          this.dateErrorMessage = false;
          this.pastDate = false ;
          this.wrongDateFormat = false;
        }
        else{
          submitObj['aci_isthereaspecificdate'] = this.datepipe.transform(submitObj.dateOfBirth, 'MM/dd/YYYY');
        }
        delete submitObj.dateOfBirth;
    
        if(this.isMulti)
        {
          this.days.forEach((d) => {
            if (d.islected) {
                switch (d.name) {
                    case 'Monday':
                        submitObj['aci_monday'] = true;
                        break;
                    case 'Tuesday':
                        submitObj['aci_tuesday'] = true;
                        break;
                    case 'Wednesday':
                        submitObj['aci_wednesday'] = true;
                        break;
                    case 'Thursday':
                        submitObj['aci_thursday'] = true;
                        break;
                    case 'Friday':
                        submitObj['aci_friday'] = true;
                        break;
                    case 'Saturday':
                        submitObj['aci_saturday'] = true;
                        break;
                    case 'Sunday':
                        submitObj['aci_sunday'] = true;
                        break;
                }
            }
            
          });
        }
        else{
          this.days.forEach((d) => {
    switch (d.name) {
        case 'Monday':
            submitObj['aci_monday'] = false;
            break;
        case 'Tuesday':
            submitObj['aci_tuesday'] = false;
            break;
        case 'Wednesday':
            submitObj['aci_wednesday'] = false;
            break;
        case 'Thursday':
            submitObj['aci_thursday'] = false;
            break;
        case 'Friday':
            submitObj['aci_friday'] = false;
            break;
        case 'Saturday':
            submitObj['aci_saturday'] = false;
            break;
        case 'Sunday':
            submitObj['aci_sunday'] = false;
            break;
          }
          });
        }
     
      
    
        let serviceValueObj: string[] = [];
        if(this.isMorning)
          {
            serviceValueObj.push('805170000')
          }
          if(this.isNoon)
          {
            serviceValueObj.push('805170001')
          }
          if(this.isEvening)
          {
            serviceValueObj.push('805170002')
          }
          if(this.isFlexible)
          {
            serviceValueObj.push('805170003')
          }
        
    
        
        if (serviceValueObj.length > 0) {
          submitObj['aci_proposedtimeofdays']  = serviceValueObj.join(',');
        }
    
        delete submitObj.specificTimeMorning;
        delete submitObj.specificTimeAfternoon;
        delete submitObj.specificTimeEvening;
        delete submitObj.specificTimeflexible;

        submitObj['aci_LeadId@odata.bind'] = `/leads(${this.leadId})`;

        submitObj['LeadId'] = this.leadId;
    
    
        submitObj['entityId'] = this.gid;

        this.sharedService
          .postRequest('groupclinic/updateClinic', submitObj)
          .subscribe(
            (response) => {
              this.loading = false;             
              this.router.navigate(['/review-details', {id: this.leadId, gid : this.gid , action : this.action}])
            },
            (errorResponse) => {
              this.loading = false;
              console.log(errorResponse);
            }
          );
    
      }
      else {
        this.showAllErrors = true;
        form.value.aci_clinicName = "" ? this.cName = false : this.cName = true;
        form.value.aci_cliniccontactname = "" ? this.oName = false : this.oName = true;
        form.value.aci_onsitecontactlastname = "" ? this.olName = false : this.olName = true;
        form.value.aci_streetaddress = "" ? this.phNum = false : this.phNum = true;
        form.value.pNum = "" ? this.addr = false : this.addr = true;
      }
 
    
  }


  openEditClinic(clinicIdd:any){
    this.router.navigate(['/review-details',{id:this.leadId, gid : clinicIdd , action : 'CE'}]);
  }

  openConfirmDialog(clinic:any){
    const dialogRef = this.modalService.open(ModalComponent);
    const clinicId = clinic.aci_clinicid;
    const showCancelButton = true;
    const showOkButton = true;
    dialogRef.componentInstance.modalObject = {clinicId, modalMessageText , okButtonText, cancelButtonText, showCancelButton, showOkButton};
    dialogRef.closed.subscribe(data => {
      if(data.event == deleteEvent){
        const id = this.clinicsList.indexOf(clinic);
        this.clinicsList.splice(id, 1);
        this.clinicCount = this.clinicsList.length;
        
      }
   });
  }

  copyClinic(clinic:any){
    this.loading = true;
    let submitObj = JSON.parse(JSON.stringify(clinic));

    if (submitObj._aci_stateid_value)
    submitObj[
      'aci_StateId@odata.bind'
    ] = `/aci_states(${submitObj._aci_stateid_value})`;
  if (submitObj._aci_zipcodeid_value)
    submitObj[
      'aci_ZipCodeId@odata.bind'
    ] = `/aci_zipcodes(${submitObj._aci_zipcodeid_value})`;


    submitObj['aci_LeadId@odata.bind'] = `/leads(${this.leadId})`;

    submitObj['LeadId'] = this.leadId;

    if(!clinic.aci_isthereaspecificdateyoudliketohold)
    {
      delete submitObj.aci_isthereaspecificdate;
      
    }

    this.sharedService.postRequest('groupclinic/createClinic', submitObj).subscribe(res => {
      this.getClinicDetailsByLead();
      this.loading = false;
     }, errorResponse => {
         this.loading = false;
       });
  }

  checkAndFetchZip(searchKey: any) {
    if (searchKey?.length == 5 && !this.fetchZipLoading) {
      this.aci_zipcode=searchKey;
      this.fetchZipCodes(this.aci_zipcode);
    }
  }

  fetchZipCodes(searchKey: any) {
    this.loading = true;
    this.fetchZipLoading = true;
    const url = `groupclinic/getZipCodes?zipcode=${searchKey}`
    this.sharedService.getRequest(url).subscribe(response => {
      if (response) {
        this.loading = false;
        this.zipCodes = response.value;
        if (response.value.length > 0) {
          this.findCity(response.value[0]);
        }
        else {
          this.isValidZipcode = false;
          this.resetZip();
        }
         this.autoFillZip=true;
          this.fetchZipLoading=false;
      }
    },
      errorResponse => {
        this.autoFillZip = false;
        this.fetchZipLoading = false;
        this.isValidZipcode = false;
        this.loading = false;
      })
  }

  findCity(response: any) {
    this.aci_city = response.aci_primarycity;
    this.aci_state = response['_aci_state_value@OData.Community.Display.V1.FormattedValue'];
    this.aci_zipcode = response.aci_name;
    this.aci_stateValue = response._aci_state_value;
    this.aci_zipcodeValue = response.aci_zipcodeid;
  
    this.zipCodes = [];
    this.isValidZipcode = true;
  }

  resetZip(){
    
      this.aci_city = '',
      this.aci_state ='',
      this.aci_zipcode= '',
      this.aci_stateValue = '',
      this.aci_zipcodeValue= ''

  }

 filterAlphabets(event: any){
    this.isValidClinicPart = (this.containsOnlyNumbers(this.aci_estimateofdoses) || this.aci_estimateofdoses == '') ? false : true ;   
  }

containsOnlyNumbers(str: any) {
    return /^[0-9]+$/.test(str);
  }
  setFocusToMorning(){
    this.isMorning=true;
    this.isAnyTimeSelected = true;
  }
  onNextButtonFocus(){
    this.previuosButtonTabIndex = 0;
  }
  onPreviousButtonFocus(){
    this.previuosButtonTabIndex = -1;
  }
  getLeadDetails() {
    const url: string = `groupclinic/getClinicLead`;
    const getParams: getParamsType = {
      entityName: 'lead',
      entityId: this.leadId,
      columns:
        'companyname'
    };
    this.loading = true;
    this.sharedService.postRequest(url, getParams).subscribe(
      (response) => {
        let spouse;
        let children;
        if (response != null) {      

          this.companyname = response.companyname;
         
        }
        this.loading = false;
      },
      (errorResponse) => {
        this.loading = false;
        console.log(errorResponse);
      }
    );
  }


}

